var EventEmitterMixin = function() {
    this.on = function (event, handler) {
        if (!this._subscriptions) {
            this._subscriptions = {};
        }

        if (this._subscriptions.hasOwnProperty(event)) {
            this._subscriptions[event].push(handler);
        } else {
            this._subscriptions[event] = [handler];
        }

        return this;
    };

    this._raiseEvent = function(event, data) {
        var handlers = this._subscriptions[event];
        if (handlers) {
            handlers.forEach(handler => handler(data));
        }
    }
}

module.exports = EventEmitterMixin;
